import { makeStyles, Theme } from "@material-ui/core";

export const useInformationStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "#EEE",
    borderRadius: "30px 0px 0px 0px",
    padding: "20px",
    marginTop: 56,
    height: "100%",
  },
  content: {
    backgroundColor: "#FFFFFF",
    minHeight: "92%",
    padding: 24,
    paddingTop: 44,
    borderRadius: "30px 30px 30px 30px",
  },
  panel: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "24px",
    [theme.breakpoints.down(400)]: {
      gap: "16px",
    },
  },
  item: {
    display: "flex",
    flex: "0 0 calc((100% - 64px) / 3)",
    scrollSnapAlign: "start",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginBottom: "32px",
    [theme.breakpoints.down(400)]: {
      marginBottom: "16px",
    },
    [theme.breakpoints.down(320)]: {
      flex: "0 0 calc((100% - 18px) / 3)",
    },
  },
  button: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    border: "none",
    padding: 0,
    [theme.breakpoints.down(400)]: {
      width: 70,
      height: 70,
    },
    [theme.breakpoints.down(350)]: {
      width: 60,
      height: 60,
    },
  },
  icon: {
    maxWidth: "70%",
    maxHeight: "70%",
    objectFit: "contain",
  },
  label: {
    marginTop: 8,
    fontSize: 14,
    lineHeight: "1.1em",
    maxHeight: "3em",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  popup: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    backgroundColor: "#0009",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1150,
  },
  popupFadeOut: {
    animation: "$fadeOut 200ms ease-out forwards",
  },
  popupContent: {
    backgroundColor: "#fff",
    padding: 24,
    borderRadius: 16,
    width: "85%",
    maxWidth: 400,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowY: "auto",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  },
  popupFadeIn: {
    animation: "$fadeIn 200ms ease-out",
  },
  modalHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 16,
    gap: 12,
  },
  modalIconWrapper: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalIcon: {
    maxWidth: "70%",
    maxHeight: "70%",
    objectFit: "contain",
  },
  modalTitle: {
    fontSize: 16,
    fontWeight: 600,
    textAlign: "center",
    marginBottom: 8,
    color: "#004B81",
  },
  actionsContainer: {
    display: "flex",
    flexDirection: "column",
    width: "80%",
    gap: "12px",
    marginTop: 16,
  },
  actionButton: {
    width: "100%",
    padding: "12px 16px",
    backgroundColor: "#004B81",
    color: "#FFFFFF",
    border: "none",
    borderRadius: 40,
    fontSize: 16,
    fontWeight: 500,
    cursor: "pointer",
    textDecoration: "none",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes fadeOut": {
    from: { opacity: 1, transform: "translateY(0)" },
    to: { opacity: 0, transform: "translateY(20px)" },
  },
  modoMayorPanel: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  modoMayorItem: {
    flex: "0 0 calc((100% - 24px) / 2)",
    [theme.breakpoints.down(400)]: {
      flex: "0 0 calc((100% - 16px) / 2)",
    },
  },
  modoMayorButton: {
    width: 100,
    height: 100,
    [theme.breakpoints.down(400)]: {
      width: 90,
      height: 90,
    },
    [theme.breakpoints.down(350)]: {
      width: 80,
      height: 80,
    },
  },
  modoMayorIcon: {
    maxWidth: "75%",
    maxHeight: "75%",
  },
}));
